const authConfig = {
  loginPath: '/auth/familysearch/login',
  logoutPath: '/auth/logout',
  registerPath: '/register/',
  permissionsLookup: {
    maxAttempts: 3,
    retryBaseDelay: 100,
  },
}

export default authConfig
